<template>
		<div>
			<InstructorMenu></InstructorMenu>	
		</div>
</template>

<script>

	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

	import InstructorMenu from "@/components/views/home/instructor/InstructorMenu";

	export default {
		components:{

			InstructorMenu
			
		},
		data(){
			
			const ADVISOR_PROFILE_ID = 3;
			return {
				
				ADVISOR_PROFILE_ID: ADVISOR_PROFILE_ID,
				section: 0
			};
		},
		computed: {
			...mapGetters(["cat_profile_id"])
		},
	}
</script>

<style scoped>

</style>